import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/alfie/agent')({
  component: () => <PageStub title="Agent Alfie" description="Autonomous AI agent mode" />,
});
